export const CREATE_CLIENT_REQUEST = "CREATE_CLIENT_REQUEST";
export const CREATE_CLIENT_RESPONSE = "CREATE_CLIENT_RESPONSE";

export const GET_CLIENTS_REQUEST = "GET_CLIENTS_REQUEST";
export const GET_CLIENTS_RESPONSE = "GET_CLIENTS_RESPONSE";

export const GET_CLIENT_REQUEST = "GET_CLIENT_REQUEST";
export const GET_CLIENT_RESPONSE = "GET_CLIENT_RESPONSE";

export const GET_ALL_CLIENTS_REQUEST = "GET_ALL_CLIENTS_REQUEST";
export const GET_ALL_CLIENTS_RESPONSE = "GET_ALL_CLIENTS_RESPONSE";

export const UPDATE_CLIENT_REQUEST = "UPDATE_CLIENT_REQUEST";
export const UPDATE_CLIENT_RESPONSE = "UPDATE_CLIENT_RESPONSE";